import React, { Children } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import isFunction from 'lodash/isFunction';
import Raven from 'raven-js';

import Loader from '../../../shared/components/loader';
import AuthManager from '../../../shared/services/AuthManager';
import { fetchOrCreatePlatformUser, sendVerificationLink } from '../../../shared/actions/auth';
import config from '../../../shared/services/config';
import Redirection from '../../../shared/services/redirection';
import cleverTap from '../../../shared/services/cleverTap';
import * as AuthEvents from '../../../shared/constants/cleverTapEvents';
import { TopBar } from '../../../shared/components/topbar';
import { TeamAccountsTable } from '../team-accounts/components/team-accounts-table';
import { Error } from '../../../shared/components/table';

class SettingUp extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    location: PropTypes.shape({
      state: PropTypes.object,
    }).isRequired,
    history: PropTypes.shape({
      push: PropTypes.func,
    }).isRequired,
  };

  state = {
    showLoader: true,
    errors: [],
    inviteResponse: {},
  };

  componentWillMount() {
    this.createPlatformUser();
  }

  redirectUser = async () => {
    const { state: historyState } = this.props.location;
    const { signup, user } = historyState;
    const isPartner = config.get('product') === 'PARTNER' && true;
    if(isPartner && !user.emailVerified) {
          const result = await sendVerificationLink(this.props.dispatch, {
           identity: user.email,
           type: 'EmailVerification',
           token: AuthManager.getFullToken()
     })   
   }
    AuthManager.setAppToken();
    const loginRedirectUrl = config.get('loginRedirectUrl');
    let merchant = AuthManager.getUser();
    let [e1, e2] = merchant.email.split('@');
    let identifier = `${e1}+${merchant.mid}@${e2}`;
    let userProfile= {
      'Name':merchant.name,
      'Email':identifier,
      'Phone':`+91${merchant.registered_mobile}`,
      'Identity':identifier,
    }
    await cleverTap.onUserLogin({'Site':userProfile});
    if (isFunction(loginRedirectUrl)) {
      loginRedirectUrl(AuthManager.getUser(), true, Redirection.getURL());
    } else {
      if(isPartner) {
        window.location.assign(signup ? '/app/web/assessment': '/app/manage_account' );
      }
      this.props.history.push({
        pathname: isPartner&& signup ? '/web/assessment' :loginRedirectUrl,
        state: {
          ...this.props.location.state,
        }
      });
    }
  }

  createPlatformUser = async () => {
    const { state: historyState } = this.props.location;
    if (!historyState) {
      this.setState({ showLoader: false, errors: [''] });
      return
    }
    const { user, userEmail } = historyState || {};
    const email = (user && user.email) || userEmail;
    try {
      this.setState({ showLoader: true, errors: [] });
      const isPartner = config.get('product') === 'PARTNER' && true;
      const payuMerchant = config.get('product', '').toUpperCase() === 'PAYU'
        || config.get('product', '').toUpperCase() === 'PAYUMONEY';
      const response = await fetchOrCreatePlatformUser(this.props.dispatch, {
        email,
        can_create: !payuMerchant,
        whatsapp_consent: historyState.whatsapp_consent || false,
        ...isPartner && { name: historyState.name }
      }, user.id);
      const { staff_invite: staffInvite } = response;
      if (staffInvite) {
        this.setState({ showLoader: false,
          showInviteMessage: true,
          inviteResponse: staffInvite });
        if (staffInvite.status) {
          AuthManager.setAppToken();
          AuthManager.persistUserToLocalStorage(response);
        }
      } else if (payuMerchant) {
        AuthManager.setAppToken();
        this.props.history.push({
          pathname: '/account/team-accounts',
          state: {
            ...this.props.location.state,
          }
        })
      } else {
        this.redirectUser();
      }
    } catch (err) {
      const response = err.errors;
      const payuMerchant = config.get('product', '').toUpperCase() === 'PAYU'
        || config.get('product', '').toUpperCase() === 'PAYUMONEY';
      if (response?.length) {
        this.setState({ showLoader: false, errors: response });
      } else if (payuMerchant) {
        AuthManager.setAppToken();
        this.props.history.push({
          pathname: '/account/team-accounts',
          state: {
            ...this.props.location.state,
          }
        })
      }
      if (response && response.need_email_verification) {
        this.props.history.replace({
          pathname: '/account/email/otp',
          state: {
            ...this.props.location.state,
            allowSkip: false,
            shiftUuid: true,
          }
        })
      } else {
        Raven.captureException(new Error('error: ' + JSON.stringify(err.errors ) + ', message: ' + err.message));
        this.setState({ showLoader: false, errors: err.message });
      }
    }
  };

  renderStaffInviteMessage = () => {
    const merchant = AuthManager.getUser();
    let [e1, e2] = merchant.email.split('@');
    let identifier = `${e1}+${merchant.mid}@${e2}`;
    const { inviteResponse } = this.state;
    cleverTap.event(AuthEvents.LOGIN_INTO_BUSINESS, {
      Identity: identifier,
      'Email id': identifier,
      MID: merchant.mid,
      UUID: merchant.uuid,
      Role: merchant.acl_role_name,
    })
    //TODO: acl_role is not going in event
    setTimeout(() => this.redirectUser(), 3000);
    if (inviteResponse.status) {
      return <React.Fragment>
          <h4 className="success">
            Invitation accepted successfully.
          </h4>
          <div className="text-center">
            <h4 className="success">
              Redirecting...
            </h4>
          </div>
        </React.Fragment>
    } else {
      return <React.Fragment>
          <h4 className="error">
            {inviteResponse.message}
          </h4>
          <div className="text-center">
            <h4 className="success">
              Redirecting...
            </h4>
          </div>
        </React.Fragment>
    }
  }

  render() {
    const { showLoader, errors, showInviteMessage } = this.state;
    const hasError = errors.length !== 0;
    return (
      <div className='textured-bg'>
        <TopBar />
        <div className="container">
          {showLoader ? 
            <div className='p-4'>
              <TeamAccountsTable
                isLoading
                teamAccounts={[]}
                onSelection={() => {}}
              />
            </div> : (
            hasError ? <div className='container tw-preflight'>
              <Error
                heading='Something went wrong'
                description={errors ? React.Children.toArray(errors.map(v => <>{v}<br /></>)) : ''}
                message={'Error!'}
                infographicType='not-found'
                actions={[{
                  text: 'Go back to Login',
                  onClick: () => {
                    localStorage.clear();
                    window.location.href = '/app/account/signin';
                  }
                }]}
              />
            </div> : null
          )}
          {showInviteMessage && <div className="staff-invite"> {this.renderStaffInviteMessage()} </div>}
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    user: state.session.User
  };
};

export default connect(mapStateToProps, null)(SettingUp);
